import {RemovedSlots} from "../../../../../server/src/base/entities/leasing/unaivailability/RemovedSlots";

export abstract class IUnavailabilityService {
    public abstract CreateUnavailability(slots:RemovedSlots):Promise<void>;
    public abstract RemoveUnavailability(slots:RemovedSlots):Promise<void>;
}

export class FakeUnavailabilityService implements IUnavailabilityService{

    private slotsAdded:RemovedSlots;
    private slotsRemoved:RemovedSlots;

    constructor(){
        this.slotsAdded = new RemovedSlots();
        this.slotsRemoved = new RemovedSlots();
    }

    public CreateUnavailability(slots: RemovedSlots): Promise<void> {
        this.slotsAdded = slots;
        return Promise.resolve();
    }

    public RemoveUnavailability(slots: RemovedSlots): Promise<void> {
        this.slotsRemoved = slots;
        return Promise.resolve();
    }

    public SlotsAdded():RemovedSlots{
        return this.slotsAdded;
    }

    public SlotRemoved():RemovedSlots{
        return this.slotsRemoved;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/IUnavailabilityService.ts